import type { Widget } from "@hireroo/presentation";

import RemoteInterviewAiEvaluationFetchContainer from "../RemoteInterviewAiEvaluation/FetchContainer";
import RemoteInterviewPlaybackFetchContainer from "../RemoteInterviewPlayback/FetchContainer";

export type GenerateRemoteInterviewReportPropsArgs = {};

export const useGenerateProps = (_args: GenerateRemoteInterviewReportPropsArgs): Widget.RemoteInterviewReportProps => {
  return {
    AiEvaluation: <RemoteInterviewAiEvaluationFetchContainer />,
    Playback: <RemoteInterviewPlaybackFetchContainer />,
  };
};
